import { Component, Inject, Prop } from 'vue-property-decorator';
import ApeironComponent from '../commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';

@Component
export default class ContactosEmergenciaComponent extends ApeironComponent {
  @Inject('solicitudService') public readonly solicitudService: () => SolicitudService;

  @Prop({ required: false })
  public solucion: Solucion;

  @Prop({ required: false })
  public solicitud: Solicitud;

  public isFetching = false;
  form = this.solicitudModel;

  public pasosPreviosMovilidad = false;
  public pasosPreviosEspMed = false;
  /**
   * Se inicializa model de form
   */
  private get solicitudModel() {
    return {
      solicitud: {
        perfil: {
          principal: {
            contactosEmergencia: [
              {
                nombre: '',
                primerApellido: '',
                segundoApellido: '',
                correo: '',
                telefono: '',
                celular: '',
              },
            ],
          },
        },
        estadoActual: '',
      },
      tags: [],
    };
  }

  created() {
    if (this.form.tags) {
      this.form.tags = this.solucion.tags;
    }
    this.getSolicitudVigente();
  }

  public isCapturable(): boolean {
    const tags = this.solucion.tags;
    if (tags.includes('MovilidadNacional')) {
      return this.pasosPreviosMovilidad;
    }
    if (tags.includes('MovilidadEspecialidadMedica')) {
      return this.pasosPreviosEspMed;
    }
    return false;
  }

  getSolicitudVigente() {
    this.isFetching = true;
    this.solicitudService()
      .find(this.solicitud.id)
      .then(
        res => {
          this.pasosPreviosMovilidad =
            !!res.beca?.id &&
            !!res.apoyoSolicitado?.apoyo &&
            res.cronogramaActividades?.length >= 3 &&
            !!res.institucion.id &&
            !!res.cotutor?.apellidoPaterno;
          this.pasosPreviosEspMed =
            !!res.beca?.id && res.cronogramaActividades?.length >= 3 && !!res.institucion.id && !!res.cotutor?.apellidoPaterno;
          this.form.solicitud = { ...res, ...JSON.parse(JSON.stringify(res)) };
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  public isSaving(): boolean {
    return (
      this.solicitud.estado === EstadoSolicitud.EN_CAPTURA &&
      this.grantService().isSolicitante(this.solicitud, this.grantService().getUsername(), this.grantService().getUsercvu)
    );
  }
}
